import { Controller } from '@hotwired/stimulus';
import Swal from 'sweetalert2';
import { useUtilities } from './mixins/utilities';
import { useRequests } from './mixins/requests';
export default class extends Controller {
	static targets = [
		'form', 'infos', 'submit', 'submitLabel', 'submitSpinner',
		'weeklyHoursInput', 'weeklyHoursDropdown',
	];
	static values = { weeklyHoursOpen: Boolean };

	connect() {
		useUtilities(this);
		useRequests(this);

		if (this.weeklyHoursOpenValue) this.dropdownToInput('open');
	}

	display(evt) {
		evt.preventDefault();
		event.stopPropagation();

		this.removeAll(this.formTarget, ['hidden', 'block']);
		this.addAll(this.infosTarget, ['hidden', 'block']);
	}

	async submit(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		if (this.submitting) return;

		const form = this.formTarget;
		this.setSubmitting(true);
		try {
			const data = await this.fetch(form.action, {
				method: 'POST',
				body: new FormData(form),
			});

			if (data.error || typeof data.html !== 'string') {
				throw new Error('Unexpected mission form response');
			}

			form.outerHTML = data.html;
		} catch (error) {
			Swal.fire({
				icon: 'error',
				title: 'Enregistrement impossible',
				text: 'Tes informations ont été conservées. Réessaie dans quelques instants.',
				confirmButtonText: 'Fermer',
			});
		} finally {
			this.setSubmitting(false);
		}
	}

	setSubmitting(submitting) {
		this.submitting = submitting;
		if (this.hasFormTarget) this.formTarget.setAttribute('aria-busy', String(submitting));
		this.submitTargets.forEach((button) => {
			button.disabled = submitting;
		});
		this.submitLabelTargets.forEach((label) => label.classList.toggle('invisible', submitting));
		this.submitSpinnerTargets.forEach((spinner) => spinner.classList.toggle('hidden', !submitting));
	}

	dropdownToInput(status = 'closed') {
		const wrapper = this.weeklyHoursInputTarget;
		const dropdown = this.weeklyHoursDropdownTarget;
		const input = wrapper.querySelector('input[type="text"]');

		if (typeof status === 'string' && status === 'open') {
			dropdown.selectedIndex = 4;
			dropdown.disabled = true;
			this.addAll(dropdown, ['cursor-not-allowed', 'disabled:opacity-75']);

			wrapper.classList.remove('hidden');
			input.disabled = false;
			return;
		}

		if (dropdown.value === 'Autre') {
			dropdown.disabled = true;
			this.addAll(dropdown, ['cursor-not-allowed', 'disabled:opacity-75']);

			wrapper.classList.remove('hidden');
			input.disabled = false;
		}
	}

	inputToDropdown() {
		const wrapper = this.weeklyHoursInputTarget;
		const dropdown = this.weeklyHoursDropdownTarget;
		const input = wrapper.querySelector('input[type="text"]');

		dropdown.selectedIndex = 0;
		dropdown.disabled = false;
		this.removeAll(dropdown, ['cursor-not-allowed', 'disabled:opacity-75']);

		wrapper.classList.add('hidden');
		input.disabled = true;
	}
}
